export const GET_ITEMS = 'GET_ITEMS'
export const GET_COLLECTIONS = 'GET_COLLECTIONS'
export const GET_ALL_TEXTS = 'GET_ALL_TEXTS'
export const GET_SINGLE = 'GET_SINGLE'
export const CHANGE_SINGLE = 'CHANGE_SINGLE'
export const GET_INDEX = 'GET_INDEX'
export const GET_COLLECTION = 'GET_COLLECTION'
export const GET_SEARCH = 'GET_SEARCH'
export const SET_CONTEXT = 'SET_CONTEXT'
export const SET_N = 'SET_N'
export const SET_BUSY = 'SET_BUSY'
export const SET_FILTER = 'SET_FILTER'
export const RESET_SINGLE_ITEM = 'RESET_SINGLE_ITEM'
export const RESET_COLLECTION = 'RESET_COLLECTION'
export const RESET_SEARCH = 'RESET_SEARCH'
export const HIDE_TEXT = 'HIDE_TEXT'
export const SHOW_TEXT = 'SHOW_TEXT'
export const SHOW_SHARE = 'SHOW_SHARE'
export const HIDE_SHARE = 'HIDE_SHARE'
export const SET_COLLECTION_ENTRY = 'SET_COLLECTION_ENTRY'



// WEBPACK FOOTER //
// ./src/store/actionTypes.js